import { render, staticRenderFns } from "./NextSection.vue?vue&type=template&id=2e1c491b&"
import script from "./NextSection.vue?vue&type=script&lang=js&"
export * from "./NextSection.vue?vue&type=script&lang=js&"
import style0 from "./NextSection.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports